import React from 'react';
import { Button, Modal } from 'antd';

import ItemTagEditor from './ItemTagEditor';
import RecordBadge, { RecordIdentity } from '../common/RecordBadge';

/**
 * ⋯ → "Tag…" (docs/plans/tags.md §5.2): the item's chips and its picker in a
 * dialog, from every view of the item (the availability rule — the list
 * card, the table row, the detail pane, the inline phone detail). Tags save
 * as they are picked, so the dialog has one button: Done.
 *
 * The item form does not open this: its own tag row is part of the form and
 * saves with it, so its "Tag…" opens that row's picker instead.
 */
export default function ItemTagsModal({
	open,
	onClose,
	item,
	card = null,
	cardType = 'Item',
	title = '',
	collection = null,
	collectionId = null,
	canEdit = false,
	onItemUpdated,
}) {
	return (
		<Modal
			open={open}
			onCancel={onClose}
			title="Tags"
			destroyOnClose
			footer={[<Button key="done" type="primary" onClick={onClose}>Done</Button>]}
		>
			<div className="modal-identity">
				<RecordIdentity
					kicker={cardType}
					badge={<RecordBadge kind="item" record={card} title={title} />}
				/>
			</div>
			{open ? (
				<ItemTagEditor
					item={item}
					collection={collection}
					collectionId={collectionId}
					canEdit={canEdit}
					onItemUpdated={onItemUpdated}
					className="item-tags--modal"
					// A dialog for changing tags: its chips stay where they are
					// rather than leave for a tag page mid-edit.
					linked={false}
				/>
			) : null}
			{canEdit ? null : (
				<p className="item-tags__note">You can read this item but not change it, so only your private tags can go on it.</p>
			)}
		</Modal>
	);
}
